<template>
    <Link v-if="link" :to="link" class="link" :class="classname">
        <slot></slot>
    </Link>
    <span v-else :class="classname" class="no-link">
        <slot></slot>
    </span>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'ui-button',

    components: {
        Link,
    },

    props: {
        link: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'bg',
        },
        size: {
            type: String,
            default: 'base',
        },
        color: {
            type: String,
            default: 'black',
        },
    },

    data() {
        return {
            classname: ['ui-button'],
        }
    },


    mounted() {
        this.classname.push('size-' + this.size);
        this.classname.push('color-' + this.color);
        this.classname.push('type-' + this.type);    
    },
}

</script>

<style lang="scss">
    .ui-button {
        display: inline-block;
        cursor: pointer;
        box-sizing: border-box;
        font-weight: normal;

        &.type-border {
            border: .2rem solid;
        }

        // &.size-large {
        //     line-height: 3rem;
        //     height: 3rem;
        //     padding: 1rem 1.5rem;
        //     font-size: var(--large-size);
        // }

        &.size-base {
            font-size: var(--base-size);
            line-height: 1;
            padding: var(--padding-50) var(--padding);
            border-radius: 3rem;
            
            &.type-border {
                line-height: 1;
            }
        }
        
        &.size-medium {
            font-size: var(--medium-size);
            line-height: 1;
            padding: 1.05rem 1.85rem;
            border-radius: 3rem;
            
            &.type-border {
                line-height: 1;
            }
        }

        &.size-large {
            font-size: var(--large-size);
            line-height: 1;
            padding: 1.2rem 3rem;
            border-radius: 4rem;
            
            &.type-border {
                line-height: 1;
            }
        }
        
        &.size-small {
            $size: 2.4rem;
            line-height: 1.2;
            height: $size;
            padding: 0.333rem 3rem;
            font-size: var(--small-size);
            border-width: .12rem;

            &.type-border {
                line-height: 1.1;
            }
        }

        &.type-bg {
            border: none;
        }

        
        &.type-bg.color-theme-2 {
            color: var(--font-color);
            background: var(--theme-2);

            &:hover {
                color: white;
                background-color: var(--font-color);
            }
        }

        &.type-bg.color-white {
            color: var(--font-color);
            background: white;
            
            &:hover {
                color: var(--font-color);
                background: var(--theme-2);
            }
        }

        &.type-bg.color-black {
            color: white;
            background: var(--font-color);
            
            &:hover {
                color: var(--font-color);
                background: var(--theme-2);
            }
        }

        // &.type-bg.color-red {
        //     color: var(--font-color);
        //     background: var(--pink);

        //     &.link:hover {
        //         color: var(--white);
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-blue {
        //     color: var(--font-color);
        //     background: var(--blue);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-orange {
        //     color: white;
        //     background: var(--orange);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }


        &.only-text {
            border-color: transparent !important;
            background-color: transparent !important;
            cursor: default;
        }



    }

    // @media only screen and (max-width: 767px) {
    //     .ui-button {

    //         // &.size-base {
    //         //     font-size: var(--base-size);
    //         //     line-height: 1.2;
    //         //     padding: var(--padding-25) var(--padding-x2);
                
    //         //     &.type-border {
    //         //         line-height: 1;
    //         //     }
    //         // }

    //         &.size-small {
    //             $size: 4.4rem;
    //             height: $size;
    //         }

          


    //     }

    // }
</style>